/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".draftTeamBlock[_ngcontent-%COMP%]   .userImg[_ngcontent-%COMP%]{width:55px;height:55px}.draftTeamBlock[_ngcontent-%COMP%]   .draftTeamRight[_ngcontent-%COMP%]{margin-left:22px;margin-top:7px}.draftTeamBlock[_ngcontent-%COMP%]   .draftTeamRight[_ngcontent-%COMP%]   .userName[_ngcontent-%COMP%]{margin-top:9px;font-size:16px}"];
export { styles as styles };
